import { Typography } from '@mui/material';
import Button from '@mui/material/Button';

import { useRedisWritesBlocked } from '@/apis/call';
import { Supporter } from '@/types';
import AgLoadingButton from '@components/AgLoadingButton';
import ButtonRow from '@components/ButtonRow';
import OtherActionsPanelAccordions from '@components/OtherActionsPanelContent/shared/OtherActionsPanelAccordions';
import type { OtherActionsPanelFormState } from '@components/OtherActionsPanelContent/shared/useOtherActionsPanelForm';

export type OtherActionsPanelLayoutProps = {
  form: OtherActionsPanelFormState;
  otherActionList: string[];
  listId: number;
  listCount: number;
  sortOrder: string;
  sortColumn: string;
  contactIds?: number[];
  selectedContacts?: Supporter[];
  applyLoading: boolean;
  onApply: () => void;
  onCancel: () => void;
  taskNotesLabel?: string;
  largeSelectionWarning?: boolean;
};

export default function OtherActionsPanelLayout({
  form,
  otherActionList,
  listId,
  listCount,
  sortOrder,
  sortColumn,
  contactIds,
  selectedContacts,
  applyLoading,
  onApply,
  onCancel,
  taskNotesLabel = 'Enter text to search for (optional)',
  largeSelectionWarning,
}: OtherActionsPanelLayoutProps) {
  const { applyDisabled } = form;
  const writesBlocked = useRedisWritesBlocked();

  return (
    <>
      <OtherActionsPanelAccordions
        form={form}
        otherActionList={otherActionList}
        listId={listId}
        listCount={listCount}
        sortOrder={sortOrder}
        sortColumn={sortColumn}
        contactIds={contactIds}
        selectedContacts={selectedContacts}
        taskNotesLabel={taskNotesLabel}
      />
      <ButtonRow>
        <Button
          variant="outlined"
          onClick={onCancel}
          data-testid="cancel-OtherActionsPanel"
          disabled={applyLoading}
        >
          Cancel
        </Button>
        <AgLoadingButton
          variant="contained"
          onClick={() => {
            if (writesBlocked) return;
            onApply();
          }}
          disabled={applyDisabled || writesBlocked}
          loading={applyLoading}
          data-testid="apply-OtherActionsPanel"
        >
          Apply
        </AgLoadingButton>
      </ButtonRow>
      {largeSelectionWarning && (
        <Typography sx={{ color: 'red', marginX: '1rem', textAlign: 'right' }}>
          <strong>Note:</strong> actions involving large numbers of contacts can take minutes and
          may fail on rare occasions
        </Typography>
      )}
    </>
  );
}
